import { createContext, useContext } from 'react'
import { UserJourneyContextProps } from './types'

const noop = (): undefined => undefined

const defaultContext: UserJourneyContextProps = {
  enabled: false,
  startJourney: noop,
  resumeJourney: noop,
  completeJourney: noop,
  addFrustration: noop,
  addFriction: noop,
  addTag: noop,
  setVariant: noop,
  getActiveJourney: noop,
  subscribe: () => noop,
}

export const UserJourneyContext = createContext<UserJourneyContextProps>(defaultContext)

export const useUserJourneyContext = (): UserJourneyContextProps => {
  return useContext(UserJourneyContext)
}
